import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useGroups } from 'root/src/client/v2/auth/hooks/useGroups';
import { useLocalStorage } from 'root/src/client/web/hooks/useLocalStorage';
// localStorage flag for internal testing: set `localStorage.setItem('dd-redesign-override', 'true')`
// in the devtools console (then reload) to force the redesign on for yourself without being in the
// `redesignBeta` auth group. `removeItem` reverts to the group-driven behavior.
export const REDESIGN_OVERRIDE_STORAGE_KEY = 'dd-redesign-override';
// Single source of truth for "is this user in the redesign experience". The cohort is: auth group
// `redesignBeta` (assigned manually, lives in the JWT -> `groups` cookie, read via `useGroups()`) OR
// the localStorage override. Used by the A/B route redirect and by any redesign feature that must gate
// itself against the legacy UI (e.g. the after-login publisher settings modal).
export const useIsRedesignCohort = () => {
    const { groups } = useGroups();
    const [override] = useLocalStorage(REDESIGN_OVERRIDE_STORAGE_KEY, false);
    return groups.includes(AuthGroup.RedesignBeta) || override === true;
};
